import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Promise from "babel-runtime/core-js/promise";
import _Object$assign from "babel-runtime/core-js/object/assign";

var _this = this;

import sysConfig from "../../../config/sysConfig.js";
import oppService from "../../../service/opp-service.js";
import imgClsConf from "./img-cls-conf.js";
import defineConfig from "../../../config/defineConfig";
import baseConfig from "../../../config/baseConfig";

var creatFunction = function creatFunction(contextObj, func, param) {
  try {
    return func.call(contextObj, param);
  } catch (error) {
    consoleError("creatFunction", error);
  }
};
var getCustBaseInfo = function getCustBaseInfo(custCode) {
  return sysConfig.$syscfg.K_Request("W0000153", {
    USER_CODE: custCode,
    CUST_CODE: custCode,
    MODEL_TYPE: "CUST_BASE_INFO"
  }).then(function (data) {
    return data && data.Data && data.Data.length && data.Data[0] || {};
  });
};

var getTemplateData = function getTemplateData(param, isPrint) {
  var that = _this;
  var paramObj = _Object$assign({}, param);
  consoleLog("当前影像类别为", paramObj.IMG_CLS || paramObj.imgClsList);
  return new _Promise(function (resolve, reject) {
    sysConfig.$syscfg.K_Request_ALL([paramObj.CUST_CODE && paramObj.CUST_CODE != "0" ? getCustBaseInfo(paramObj.CUST_CODE) : {}, oppService.getOppBusiData(paramObj.B_SNO)]).then(function (data) {
      var _this2 = this;

      var custInfo = data[0],
          busiData = data[1],
          custBasicInfo = sysConfig.$syscfg.isOpenAcctBiz(busiData.BUSI_CODE) ? {
        CUST_FNAME: busiData.CUST_FNAME,
        CUST_NAME: busiData.CUST_NAME,
        ID_CODE: busiData.ID_CODE,
        ID_TYPE: busiData.ID_TYPE,
        ID_EXP_DATE: _.get(busiData, "BIZ_DATA.BASE_INFO.ID_EXP_DATE"),
        ID_ADDR: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.CUST_INFO.ID_ADDR") : _.get(busiData, "BIZ_DATA.BASE_INFO.ID_ADDR2"),
        ADDRESS: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.OTHER_INFO.ADDRESS") : _.get(busiData, "BIZ_DATA.CONTACT_INFO.CORP_ADDR"),
        CITIZENSHIP: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.OTHER_INFO.CITIZENSHIP") : _.get(busiData, "BIZ_DATA.AGENT_INFO.CITIZENSHIP"),
        SEX: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.CUST_INFO.SEX") : "",
        OCCU_TYPE: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.OTHER_INFO.OCCU_TYPE") : "",
        MOBILE_TEL: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.OTHER_INFO.MOBILE_TEL") : _.get(busiData, "BIZ_DATA.CONTACT_INFO.MOBILE_TEL"),
        TEL: busiData.USER_TYPE == "0" ? _.get(busiData, "BIZ_DATA.OTHER_INFO.TEL") : _.get(busiData, "BIZ_DATA.CONTACT_INFO.WELL_TEL")
      } : {
        CUST_FNAME: custInfo.USER_FNAME,
        CUST_NAME: custInfo.USER_NAME,
        ID_CODE: custInfo.ID_CODE,
        ID_TYPE: custInfo.ID_TYPE,
        ID_EXP_DATE: custInfo.ID_EXP_DATE,
        ID_ADDR: custInfo.ID_ADDR,
        ADDRESS: custInfo.ADDRESS || custInfo.MAIL_ADDR,
        ZIP_CODE: custInfo.MAIL_ZIP_CODE,
        CITIZENSHIP: custInfo.CITIZENSHIP,
        SEX: custInfo.SEX,
        OCCU_TYPE: ["V0115", "V0049", "V0130"].includes(busiData.BUSI_CODE) ? busiData.OCCU_TYPE : custInfo.OCCU_TYPE,
        MOBILE_TEL: ["V0126", "V0115", "V0130", "V0049"].includes(busiData.BUSI_CODE) ? busiData.MOBILE_TEL : custInfo.MOBILE_TEL,
        TEL: custInfo.TEL
      };
      var qsVersion = defineConfig.$definecfg.QSJGDM_CONST[baseConfig.$basecfg.qsVersion];
      var oppBusiData = _Object$assign(busiData, {
        IMG_CLS: paramObj.IMG_CLS,
        imgClsList: paramObj.imgClsList
      }, custBasicInfo);
      var commonFunction = _.get(imgClsConf[qsVersion], "common.loadBusiData");
      var newData = {};
      sysConfig.$syscfg.K_Request_ALL([typeof commonFunction === "function" ? creatFunction(imgClsConf[qsVersion]["common"], commonFunction, oppBusiData) : oppBusiData]).then(function () {
        var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(comRes) {
          var i, imgCls, newObj;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  newData = comRes[0];
                  i = 0;

                case 2:
                  if (!(i < paramObj.imgClsList.length)) {
                    _context.next = 12;
                    break;
                  }

                  imgCls = paramObj.imgClsList[i];

                  if (!(typeof _.get(imgClsConf, qsVersion + "." + imgCls + ".loadBusiData") === "function")) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 7;
                  return imgClsConf[qsVersion][imgCls]["loadBusiData"](newData, oppBusiData);

                case 7:
                  newObj = _context.sent;

                  newData = _Object$assign(newData, newObj);

                case 9:
                  i++;
                  _context.next = 2;
                  break;

                case 12:
                  resolve({
                    templateData: newData
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (e) {
        reject(e);
      });
    }).catch(function (e) {
      reject(e);
    });
  });
};

export default {
  getTemplateData: getTemplateData
};


//////////////////
// WEBPACK FOOTER
// ./src/components/imageNode/child/template-and-data.js
// module id = 1129
// module chunks = 2